import ApplicationController from './application_controller';

// Empty controller enables easy full-page stimulates through admin_webhooks_channel
export default class extends ApplicationController {}
